// Pobieranie listy załączników wątku

import { orionAxios } from '../orionApi';
import { ChatAttachment } from './orionTypes';

/**
 * Pobiera listę wszystkich załączników w wątku
 * @param threadId - UUID wątku
 * @returns tablica załączników z metadanymi
 */
export const getAttachments = async (threadId: string): Promise<ChatAttachment[]> => {
  const response = await orionAxios.get<ChatAttachment[]>(
    `/api/aiassistant/get-attachments/${threadId}`
  );
  return response.data;
};

